import cssClasses from '../helpers/cssClasses';

/**
 * DOM selectors.
 */
const selectors = {
  navTrigger: '[js-mobile-nav="toggle"]',
  navHide: '[js-mobile-nav="hide"]',
  mobileNav: '[js-nav="mobile"]',
  siteHeader: '[js-site-header="true"]',
  siteHeaderOverlay: '[js-site-header="overlay"]',
  meganavTrigger: '[js-meganav="trigger"]',
  siteNavitem: '.site-nav__item',
  fixedContainer: '[js-site-header="fixed-container"]',
  topBarCurrency: '[js-top-bar="currency"]',
};

export default () => {
  // DOM node selectors.
  const nodeSelectors = {
    navTrigger: document.querySelectorAll(selectors.navTrigger),
    navHide: document.querySelector(selectors.navHide),
    mobileNav: document.querySelector(selectors.mobileNav),
    topBarCurrency: document.querySelector(selectors.topBarCurrency),
    siteHeader: document.querySelector(selectors.siteHeader),
    siteHeaderOverlay: document.querySelector(selectors.siteHeaderOverlay),
    meganavTrigger: document.querySelectorAll(selectors.meganavTrigger),
    siteNavitem: document.querySelectorAll(selectors.siteNavitem),
    fixedContainer: document.querySelector(selectors.fixedContainer),
  };

  // Set events Listeners.
  function setEventListeners() {
    nodeSelectors.navTrigger.forEach((trigger) => {
      trigger.addEventListener('click', toggleActiveState);
    });

    // nodeSelectors.navTrigger.addEventListener('click', toggleActiveState);
    nodeSelectors.navHide.addEventListener('click', removeActiveState);
    nodeSelectors.siteHeaderOverlay.addEventListener(
      'click',
      removeActiveState,
    );
    document.documentElement.addEventListener('keydown', handleKeydown);
  }

  /**
   * Set Event Bus listeners
   * These are normal trigger from other JS events.
   */
  function setEvenBustListeners() {
    Karmoon.EventBus.listen('ScrollDirection:down', (position) => {
      enableFixedHeader(position);
    });

    Karmoon.EventBus.listen('ScrollDirection:up', (position) => {
      disableFixedHeader(position);
    });
  }

  function enableFixedHeader(position) {
    if (position > nodeSelectors.fixedContainer.offsetTop) {
      nodeSelectors.fixedContainer.classList.add(cssClasses.active);
    }
  }

  function disableFixedHeader(position) {
    if (position < nodeSelectors.fixedContainer.offsetTop) {
      nodeSelectors.fixedContainer.classList.remove(cssClasses.active);
    }
  }

  function toggleActiveState() {
    if (nodeSelectors.mobileNav.classList.contains(cssClasses.active)) {
      removeActiveState();
    } else {
      addActiveState();
    }
  }

  function handleKeydown(event) {
    if (event.keyCode === 27) {
      removeActiveState();
      return true;
    }
    return false;
  }

  function removeActiveState() {
    nodeSelectors.mobileNav.classList.remove(cssClasses.active);
    nodeSelectors.topBarCurrency.classList.remove(cssClasses.active);
    document.querySelector('body').style.overflowY = 'initial';
  }

  function addActiveState() {
    nodeSelectors.mobileNav.classList.add(cssClasses.active);
    nodeSelectors.topBarCurrency.classList.add(cssClasses.active);
    document.querySelector('body').style.overflowY = 'hidden';
  }

  function useIDtoToggle() {
    const IDToggleMobNav = document.getElementById('js-mobile-nav-toggle');
    IDToggleMobNav.addEventListener('click', removeActiveState);
  }

  // Initialise component.
  function init() {
    setEventListeners();
    setEvenBustListeners();
    useIDtoToggle();
  }

  // Expose public interface.
  return Object.freeze({
    init,
    removeActiveState,
  });
};
